import { render, staticRenderFns } from "./shares.vue?vue&type=template&id=60032e66"
import script from "./shares.vue?vue&type=script&lang=js"
export * from "./shares.vue?vue&type=script&lang=js"
import style0 from "./shares.vue?vue&type=style&index=0&id=60032e66&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports